export const BOARD_OPTIONS = ["CBSE", "ICSE", "NIOS", "CISCE", "IB"];
export const CLASS_OPTIONS = [];
for (let i = 1; i <= 12; i++) {
  // CLASS_OPTIONS.push(`Class ${i}`);
   CLASS_OPTIONS.push(`${i}`);
}

export const SUBJECT_OPTIONS = [
  "Python",
  "JavaScript",
  "C#",
  "C++",
  "C",
  "Java",
  "PHP",
  "English",
  "Hindi",
  "Mathemetics",
  "Science",
  "Social Science",
  "Computer Science",
  "Sanskrit",
  "Physical Education",
  "Art Education",
  "English (Language And lit.)",
  "Hindi(Course A)",
  "Hindi (Course B)",
  "Physics",
  "Chemistry",
  "Biology",
  "Computer Applications",
  "Information Technology",
  "Home Science",
  "Accountancy",
  "Bussiness Studies",
  "Economics",
  "Engineering Graphics",
  "Entrepreneurship",
  "Biotechnology",
  "Phychology",
  "History",
  "Geography",
  "Political Science",
  "Sociology",
  "Philosophy",
  "Informatics Practices",
];

// export const DIVISION_OPTIONS = ["A", "B", "C", "D",]
export const DIVISION_OPTIONS = Array.from(
  { length: 26 },
  (_, i) => String.fromCharCode(65 + i)
);